@if (isHeaderGlobalSearchModalOpen()) {
<div class="global-search-modal-wrap"
  (click)="isSearchExpanded.set(false)" role="button" tabindex="0" (keydown.enter)="isSearchExpanded.set(false)" (keydown.space)="$event.preventDefault(); isSearchExpanded.set(false)"> <!-- NOSONAR: click-outside-to-dismiss backdrop; wraps role=dialog content, cannot become a native button -->
  <section class="global-search-modal"
    [style.left.px]="headerGlobalSearchModalLeftPx()"
    [style.width.px]="headerGlobalSearchModalWidthPx()"
    (click)="stopProp($event)" aria-label="Global search results" (keydown.enter)="stopProp($event)" (keydown.space)="$event.preventDefault(); stopProp($event)">
    <header class="global-search-modal-head">
      <div class="global-search-modal-title">
        Search results for: <strong>{{ headerGlobalSearchQuery().trim() }}</strong>
      </div>
      @if (!headerGlobalSearchLoading() && headerGlobalSearchFlatResults().length > 0) {
      <div class="global-search-modal-count">({{ headerGlobalSearchFlatResults().length }})</div>
      }
      <button type="button" class="global-search-modal-close" (click)="isSearchExpanded.set(false)" aria-label="Close search">
        &#x2715;
      </button>
    </header>

    @if (headerGlobalSearchFlatResults().length === 0 && headerGlobalSearchQuery().trim().length < 3) {
    <div class="global-search-modal-state">
      Type at least 3 characters to search clients, tasks, team, notes, and pages.
    </div>
    } @else if (headerGlobalSearchFlatResults().length === 0 && (headerGlobalSearchLoading() || headerGlobalSearchDebouncing())) {
    <div class="global-search-modal-state">
      Loading search results...
    </div>
    } @else if (headerGlobalSearchFlatResults().length === 0 && headerGlobalSearchError()) {
    <div class="global-search-modal-state global-search-modal-state--error">
      {{ headerGlobalSearchError() }}
    </div>
    } @else if (headerGlobalSearchFlatResults().length === 0) {
    <div class="global-search-modal-state">
      No results found.
    </div>
    } @else {
    <div class="global-search-modal-list">
      @for (group of headerGlobalSearchGroupedResults(); track group.key) {
      <div class="global-search-group-title">{{ group.title }}</div>
      @for (item of group.items; track headerGlobalSearchItemTrackId(item)) {
      <button
        type="button"
        class="global-search-item"
        [class.global-search-item--active]="headerGlobalSearchItemFlatIndex(item) === headerGlobalSearchActiveIndex()"
        (mouseenter)="headerGlobalSearchActiveIndex.set(headerGlobalSearchItemFlatIndex(item))"
        (click)="onHeaderGlobalSearchResultClick(item)">
        <div class="global-search-item-leading">
          @switch (headerGlobalSearchModuleKey(item)) {
            @case ('actions') {
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M12 5v14"></path>
                <path d="M5 12h14"></path>
              </svg>
            }
            @case ('pages') {
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <rect x="3" y="3" width="18" height="18" rx="2"></rect>
                <path d="M3 9h18"></path>
                <path d="M9 21V9"></path>
              </svg>
            }
            @case ('clients') {
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M20 21a8 8 0 0 0-16 0"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            }
            @case ('teams') {
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            }
            @case ('tasks') {
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M9 11l3 3L22 4"></path>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
              </svg>
            }
            @case ('notes') {
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
              </svg>
            }
            @default {
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
            }
          }
        </div>
        <div class="global-search-item-content">
          <div class="global-search-item-top">
            <span class="global-search-item-module">{{ headerGlobalSearchItemModuleLabel(item) }}</span>
            @if (item.dueDate) {
            <span class="global-search-item-due">Due: {{ item.dueDate | pmDate }}</span>
            }
          </div>
          <div class="global-search-item-name">{{ item.name }}</div>
          <div class="global-search-item-meta">
            @if (item.hint) {
            <span>{{ item.hint }}</span>
            }
            @if (item.clientName) {
            <span>Client: {{ item.clientName }}</span>
            }
            @if (item.createdOn) {
            <span>Created: {{ item.createdOn | pmDate }}</span>
            }
          </div>
        </div>
      </button>
      }
      }
    </div>
    }
  </section>
</div>
}
